var Icon = /** @class */ (function () {
    function Icon(iconOption) {
        this.size = iconOption.size;
        this.image = iconOption.image;
    }
    return Icon;
}());
export default Icon;
